var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog-scroll-lock', {
    attrs: {
      "scrollable": "",
      "value": true,
      "width": _vm.width,
      "persistent": _vm.persistent
    },
    on: {
      "input": function ($event) {
        return _vm.resolve(_vm.dismiss || _vm.buttons[0]);
      }
    }
  }, [_c('v-card', {
    staticClass: "pt-4",
    attrs: {
      "dark": _vm.dark,
      "color": _vm.color
    }
  }, [_vm.title ? _c('v-card-title', {
    staticClass: "pt-0 overflow-auto",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm.msg ? _c('v-card-text', {
    staticClass: "break-word",
    domProps: {
      "innerHTML": _vm._s(_vm.msg)
    }
  }) : _vm._e(), _c('v-card-actions', [_c('v-spacer'), _vm.loadTimeout ? _c('v-progress-circular', {
    staticClass: "mr-3",
    attrs: {
      "indeterminate": "",
      "size": "24",
      "width": "2",
      "color": "grey"
    }
  }) : _vm._e(), _vm._l(_vm.buttons, function (btn) {
    return _c('v-btn', {
      key: btn,
      attrs: {
        "text": "",
        "disabled": !!_vm.loadTimeout,
        "color": btn == _vm.primary ? 'primary' : null
      },
      on: {
        "click": function ($event) {
          return _vm.resolve(btn);
        }
      }
    }, [_vm._v(" " + _vm._s(btn) + " ")]);
  })], 2), _vm.finePrint ? [_c('v-divider'), _c('v-card-text', {
    staticClass: "pt-5 break-word caption font-italic",
    domProps: {
      "innerHTML": _vm._s(_vm.finePrint)
    }
  })] : _vm._e()], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }